import { Heading, Paragraph } from '@pandiafi/design-system'
import { DateTime } from 'luxon'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { RightOfOccupancyFeeBreakdown } from '../../../../../common/generated/residentApiSchemas'
import { Divider } from '../../Divider'
import { localizeCurrency } from '../../utils'
import { FeeRow } from '../FeeRow/FeeRow'
import { FeeTotalRow } from '../FeeTotalRow/FeeTotalRow'

interface FeeBreakdownProps {
  breakdown: RightOfOccupancyFeeBreakdown
  title: string
  indexInfoKey:
    | 'payments:rightOfOccupancyFee.currentValueIndexInfo'
    | 'payments:rightOfOccupancyFee.valueAtTerminationIndexInfo'
  totalLabel: string
}

export const FeeBreakdown: React.FC<FeeBreakdownProps> = ({
  breakdown,
  title,
  indexInfoKey,
  totalLabel,
}) => {
  const { t } = useTranslation(['payments'])

  return (
    <section className="mt-8">
      <Heading element="h2" size="m" bold className="mb-2">
        {title}
      </Heading>
      {breakdown.buildingCostIndexMonth && (
        <Paragraph small light className="mb-4">
          {t(indexInfoKey, {
            month: DateTime.fromFormat(
              breakdown.buildingCostIndexMonth,
              'yyyy-MM'
            ).toFormat('M/yyyy'),
          })}
        </Paragraph>
      )}
      <FeeRow
        label={t('payments:rightOfOccupancyFee.originalValue')}
        value={localizeCurrency(breakdown.originalValue)}
      />
      <FeeRow
        label={t('payments:rightOfOccupancyFee.indexAdjustment')}
        value={`+ ${localizeCurrency(breakdown.indexAdjustmentValue)}`}
      />
      <FeeRow
        label={t('payments:rightOfOccupancyFee.improvementValue')}
        value={`+ ${localizeCurrency(breakdown.improvementValue)}`}
      />
      <Divider />
      <FeeTotalRow
        label={totalLabel}
        value={localizeCurrency(breakdown.total)}
      />
    </section>
  )
}
